export var ValidateStatus;
(function (ValidateStatus) {
    ValidateStatus["Success"] = "success";
    ValidateStatus["Error"] = "error";
    ValidateStatus["Warning"] = "warning";
    /* eslint-disable @typescript-eslint/naming-convention */
    /** @deprecated Use ValidateStatus.Success instead */
    ValidateStatus["success"] = "success";
    /** @deprecated Use ValidateStatus.Error instead */
    ValidateStatus["error"] = "error";
    /** @deprecated Use ValidateStatus.Warning instead */
    ValidateStatus["warning"] = "warning";
    /* eslint-enable @typescript-eslint/naming-convention */
})(ValidateStatus || (ValidateStatus = {}));
//# sourceMappingURL=types.js.map